var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5945 14.6552C16.9373 14.8787 16.2328 15 15.5 15C14.4583 15 13.4739 14.755 12.6012 14.3194L7.4907 19.43L4.57008 16.5094L9.68059 11.3988C9.24503 10.5261 9 9.54168 9 8.50002C9 7.7672 9.12127 7.06271 9.34484 6.40552L17.5945 14.6552ZM10.0303 15.0303C10.3232 14.7374 10.3232 14.2626 10.0303 13.9697C9.73744 13.6768 9.26256 13.6768 8.96967 13.9697L7.96967 14.9697C7.67678 15.2626 7.67678 15.7374 7.96967 16.0303C8.26256 16.3232 8.73744 16.3232 9.03033 16.0303L10.0303 15.0303Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50943 17.5701L6.43005 20.4907L5.52565 21.3951C4.71914 22.2016 3.41154 22.2016 2.60504 21.3951C1.79853 20.5886 1.79853 19.281 2.60504 18.4745L3.50943 17.5701Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0236 13.963L10.037 4.97636C11.1946 3.18541 13.2089 2 15.5 2C19.0899 2 22 4.91015 22 8.5C22 10.7911 20.8146 12.8054 19.0236 13.963Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.d3dba845c514a5c15e312be7c00ab08a.svg";
export { ForwardRef as ReactComponent };